export default __webpack_public_path__ + "static/media/sabonCeBold.2cf4167d.ttf";